var render, staticRenderFns
import script from "./VueTreeselect.vue?vue&type=script&lang=js"
export * from "./VueTreeselect.vue?vue&type=script&lang=js"
import style0 from "./VueTreeselect.vue?vue&type=style&index=0&id=70b710c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports